<template>
  <div
    :class="{ dInput: true, editing: isEditing }"
    v-click-outside="hide"
    @dblclick="editVal(value)"
  >
    <div class="view" v-if="!isEditing">
      <label>{{ model }}</label>
    </div>
    <input
      v-if="isEditing"
      type="text"
      v-model="model"
      @keyup.enter="doneEdit"
      @keyup.esc="cancelEdit"
      class="edit"
    />
  </div>
</template>

<script>
export default {
  name: "TargetCell",
  props: {
    row: {
      type: Object,
      default: () => {
        return {};
      }
    },
    column: {
      type: String,
      default: ""
    },
    month: {
      type: Number
    },
    year: {
      type: Function
    }
  },
  data() {
    return {
      isEditing: false,
      editModel: null
    };
  },
  updated() {
    this.beforeEditCache = this.model;
  },
  computed: {
    value() {
      return this.row[this.column];
    },
    model: {
      get() {
        const item = this.$store.getters["rabbey_table/getItem"]({
          item: this.row,
          key: "UserID"
        });
        return item[this.column];
      },
      set(val) {
        this.editModel = val;
      }
    }
  },
  methods: {
    editVal(val) {
      this.beforeEditCache = val;
      this.editModel = val;
      this.isEditing = true;
    },
    doneEdit() {
      if (!this.editModel) {
        return;
      }

      this.isEditing = false;

      const year = this.year();
      this.$http
        .put(`/api/SalesApi/UpdateVendorForCrudPropose`, {
          UserID: this.row.User.Id,
          Year: year,
          Month: this.month,
          Amount: parseInt(this.editModel),
          CompanyId: this.currentCompany
        })
        .then(() => {
          const itemm = JSON.parse(JSON.stringify(this.row));
          itemm[this.column] = this.editModel;

          this.$store.commit("rabbey_table/UPDATE_ITEM", {
            key: "UserID",
            item: itemm
          });
        })
        .catch((error) => {
          this.$message.error(error.response.data.Message || "Error");
        });
    },
    cancelEdit() {
      this.isEditing = false;
      this.editModel = null;
    },
    hide() {
      this.cancelEdit();
    }
  }
};
</script>

<style lang="css" scoped>
.dInput {
  width: 100%;
  margin: auto;
}

.edit {
  position: relative;
  margin: 0;
  width: 100%;
  font-family: inherit;
  font-weight: inherit;
  line-height: 1.4em;
  color: inherit;
  padding: 6.5px;
  border: 1px solid #999;
  box-shadow: inset 0 -1px 5px 0 rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.dInput.editing .edit {
  display: block;
}

.dInput.editing .view {
  display: none;
}

.dInput .edit {
  display: none;
}

.dInput .view {
  margin: auto;
}
</style>
